export const ORDER_STEPS = {
    1: "Загрузите скрин корзины",
    2: "Найдите наш товар",
    3: "Добавить товар в избранное",
    4: "Реквизиты для перевода кэшбэка",
    5: "Оформление заказа",
    6: "Получение товара",
    7: "Отчет об отзыве",
    8: "Отчет по сделке"
}